import axios from '../../../axios';
import DiceSearch from '../types/DiceSearch';

export const searchDice = async (query: DiceSearch) =>
  axios.post('/candidatesearch/api/job-board-search-account/search/dice', query);
